/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IGarminStopHistory, IGarminStopHistoryParams } from '../../../core/models';
import { GetGarminStopHistory } from '../../../core/store/actions';
import { getGarminStopHistory } from '../../../core/store/selectors';

@Component({
  selector: 'fm-garmin-stop-history',
  templateUrl: './garmin-stop-history.component.html',
  styleUrls: ['./garmin-stop-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GarminStopHistoryComponent implements OnInit {
  @Input()
  public history$: Observable<IGarminStopHistory[]>;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) private readonly _dialogData: { garminStopHistoryParams: IGarminStopHistoryParams },
    private readonly _store: Store
  ) {}

  public ngOnInit(): void {
    this._store.dispatch(new GetGarminStopHistory(this._dialogData.garminStopHistoryParams));
    this.history$ = this._store.pipe(select(getGarminStopHistory));
  }
}
